import SteelcaseImage from "../layout/SteelcaseImage/SteelcaseImage";

interface SwatchVariantIconProps {
    id: string;
    finishName: string;
    swatchURL: string;
    onIconClickHandler?: () => void;
    isActive: boolean;
    title: string;
    classNames?: Partial<SwatchVariantIconClasses>
}

interface SwatchVariantIconClasses {
    root: string;
    img: string;
    icon: string;
    active: string;
}

export default function SwatchVariantIcon({ id, finishName, swatchURL, onIconClickHandler, isActive, title, classNames }: SwatchVariantIconProps) {
    return (
        <button onClick={onIconClickHandler} style={{ margin: 0, padding: 0, border: "none", outline: "none", backgroundColor: "transparent", color: "inherit" }}>
            <span 
            className={[
                classNames && classNames.icon ? classNames.icon : `finish-variant-icon__icon`,
                classNames && classNames.active ? (isActive ? classNames.active : "") : (isActive ? "finish-variant-icon__icon--active" : ""),
            ]
                .filter(Boolean)
                .join(' ')}
            > 
                <SteelcaseImage title={title} src={swatchURL} altText={finishName} className={classNames && classNames.img ? "finish-details__swatch-variants-img" : "finish-variant-icon__icon-img"} deliveryOptions={{ seoFileName: finishName, format: "webp", width: "250", crop: {cropType: "absolute", cropValues: "0,0,500,500"}, quality: "60" }} />
            </span>
        </button>
    )
}